<script>
export default {
  methods: {
    handleNumberPresentation(options) {
      if (
        !options.varName ||
        !options.varTempName ||
        options.varName === options.varTempName ||
        this.$data[options.varName] === undefined ||
        this.$data[options.varTempName] === undefined
      ) {
        return this.$data[options.varName]
      }

      if (!options.prepareForPresentation) {
        // Klargør feltet til edit. Al "styling" fjernes, så man frit kan ændre
        this.$data[options.varTempName] = this.$data[options.varName]
      } else {
        this.$data[options.varTempName] = this.sanitizeNumber(
          this.$data[options.varTempName],
          options
        )
        this.$data[options.varName] = this.$data[options.varTempName]
        let value = this.$data[options.varName]

        if (options.separateBythousands) {
          value = this.thousandSeparation(value, options.isInteger)
        }

        // if value is empty, there's no need to bother with pre- or postfix
        if (value === '') {
          this.$data[options.varTempName] = value
          return
        }

        if (options.prefix) {
          value = `${options.prefix} ${value}`
        }

        if (options.postfix) {
          value = `${value} ${options.postfix}`
        }

        this.$data[options.varTempName] = value
      }
    },
    prefix(value, prefix) {
      return `${prefix} ${value}`
    },
    postfix(value, postfix) {
      return `${value} ${postfix}`
    },
    thousandSeparation(number, isInteger) {
      if (!number || (number + '').length === 0) return ''

      const integerValue = this.getIntegerValue(
        this.getCleanNumber(number)
      ).replace(/\B(?=(\d{3})+(?!\d))/g, '.')

      if (isInteger) {
        return this.getNumberOutput(integerValue, '')
      }

      const decimalValue = this.getDecimalValue(number)

      return this.getNumberOutput(integerValue, decimalValue)
    },
    getCommaIndex(number) {
      return number.indexOf(',')
    },
    getIntegerValue(number) {
      const commaIndex = this.getCommaIndex(number)
      if (commaIndex === -1) {
        return number
      }
      return number.slice(0, commaIndex)
    },
    getDecimalValue(number) {
      const commaIndex = this.getCommaIndex(number)
      if (commaIndex === -1) return ''

      const value = number.substring(commaIndex + 1)
      if (value.length === 0) return ''

      // Multiple commas will be removed, leaving only one
      return ',' + value.replace(/[^0-9]/g, '')
    },
    sanitizeNumber(number, options) {
      const integerValue = this.getIntegerValue(this.getCleanNumber(number))

      if (options.isInteger) {
        return this.getNumberOutput(integerValue, '')
      }

      const decimalValue = this.getDecimalValue(number)

      return this.getNumberOutput(integerValue, decimalValue)
    },
    /* Removing all but digits and commas from the incoming string */
    getCleanNumber(number) {
      return number.replace(/[^0-9,]/g, '')
    },
    getNumberOutput(integerValue, decimalValue) {
      if (decimalValue === undefined || decimalValue === '') {
        return integerValue ?? ''
      }

      if (integerValue === undefined || integerValue === '') {
        return '0' + decimalValue
      }

      return integerValue + decimalValue
    },
  },
}
</script>
